import React, { useEffect, useState } from 'react';
import { Box, Grid, MenuItem, Modal, Tab, Tabs } from '@mui/material';
import { ApiManager } from '../../services/api';
import { useNavigate, useParams } from 'react-router-dom';
import { toAbsolutePath } from '../../constants/shared-methods';
import { CSVLink } from 'react-csv';
import { routesName } from '../../constants/routes-name';
import moment from 'moment/moment';
import {
  BreadcrumbsWrapper,
  MessagePopup,
  TextFieldWrapper,
} from '../../components';
import * as yup from 'yup';
import { useSelector } from 'react-redux';
import useNotification from '../../hooks/useNotification';
import { Formik } from 'formik';
import { validationSchema } from '../../constants/validationSchema';
import Swal from 'sweetalert2';

function Component() {
  const params = useParams();
  const { successNonification, errorNonification } = useNotification();
  const { user } = useSelector(({ user }) => user);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isAward, setIsAward] = useState(false);
  const [awardedUser, setAwardedUser] = useState('');
  const [bids, setBids] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [isViewBid, setIsViewBid] = useState(false);
  const [tenderData, setTenderData] = useState({
    tenderTitle: '',
    refNo: '',
    publicationDate: '',
    publicationTime: '',
    publicationTimeZone: '',
    submissionDate: '',
    submissionTime: '',
    submissionTimeZone: '',
    beneficiatyLocation: '',
    unspscAndCpvCode: '',
    procedureType: '',
    introduction: '',
    files: [],
    submissionInstructions: '',
    deadlineForQueries: '',
    userKey1: '',
    userKey2: '',
    userKey3: '',
    openBy: [],
  });

  const toggleViewBid = () => setIsViewBid((view) => !view);
  const toggleIsAward = () => setIsAward((view) => !view);

  const getTenderDetailById = async () => {
    const res = await ApiManager.getTenderDetailById(params.id);
    if (res?.status === 200 && res?.data?.result) {
      const { ...data } = res.data.result;
      setTenderData({ ...tenderData, ...data });
    }
    setLoading(false);
  };

  const getAllBidsByTenderId = async () => {
    const res = await ApiManager.getAllBidsByTenderId(params.id);
    if (res?.status === 200 && res?.data?.result) {
      const data = res.data.result;
      setBids(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (params.id) {
      getTenderDetailById();
      getAllBidsByTenderId();
    } else {
      setLoading(false);
    }
  }, [params]);
  useEffect(() => {
    if (bids && Array.isArray(bids)) {
      var arr = [
        [tenderData?.tenderTitle || ''],
        [
          'Tender Title',
          'Supplier',
          'Email',
          'Phone',
          'Company',
          'Country',
          'City',
          'Address',
          'Files Link',
        ],
      ];
      bids.map((bid, item) => {
        if (Array.isArray(bid.files)) {
          bid.files.map((file, ind) => {
            var data = [];

            if (ind === 0) {
              data.push(bid?.tender?.tenderTitle || '');
              data.push(bid?.user?.name || '');
              data.push(bid?.user?.email || '');
              data.push(bid?.user?.phone || '');
              data.push(bid?.company?.name || '');
              data.push(bid?.company?.country || '');
              data.push(bid?.company?.city || '');
              data.push(bid?.company?.address || '');
            } else {
              data.push('');
              data.push('');
              data.push('');
              data.push('');
              data.push('');
              data.push('');
              data.push('');
              data.push('');
            }

            arr.push([...data, toAbsolutePath(file)]);
          });
        }
      });
      setCsvData([...arr]);
    }
  }, [bids]);

  const openDownloadBidForTender = async (data) => {
    const res = await ApiManager.openDownloadBidForTender(params.id, data);
    if (res?.status === 200 && res?.data?.result) {
      getTenderDetailById();
      successNonification(res.data?.message || 'Done');
      toggleViewBid();
    } else {
      errorNonification(res.data?.message || 'Fail');
    }
    setLoading(false);
  };

  const didOpen = (openBy = [], me = '') => {
    var isOpen = false;

    openBy.map((item) => {
      if (item.user === me) {
        isOpen = true;
      }
    });

    return isOpen;
  };

  const didAllMembersOpen = () => {
    let userKey1 = true;
    let userKey2 = true;
    let userKey3 = true;
    if (tenderData) {
      if (tenderData.userKey1) {
        userKey1 =
          tenderData.openBy.findIndex(
            (item) => item.user === tenderData.userKey1._id
          ) !== -1;
      }
      if (tenderData.userKey2) {
        userKey2 =
          tenderData.openBy.findIndex(
            (item) => item.user === tenderData.userKey2._id
          ) !== -1;
      }
      if (tenderData.userKey3) {
        userKey3 =
          tenderData.openBy.findIndex(
            (item) => item.user === tenderData.userKey3._id
          ) !== -1;
      }
    }
    return userKey1 && userKey2 && userKey3;
  };

  const breadcrumbs = [
    { title: 'Dashboard', path: routesName.dashboard },
    { title: 'All Tenders', path: routesName.tenderListing },
    { title: 'Bids Download' },
  ];

  const handleAward = async (awardTo) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You to award this user!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, award it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Enter your password',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
          },
          showCancelButton: true,
          confirmButtonText: 'Verify',
          showLoaderOnConfirm: true,
          preConfirm: async (password) => {
            const loginUser = await ApiManager.verifyPassword({
              password,
            });
            if (loginUser.status === 200) {
              const data = {
                awardTo: awardTo,
                tender: params.id,
              };
              const res = await ApiManager.awardTender(data);

              if (res.status === 200) {
                getTenderAwardedTo();
                successNonification('Tender has been awarded.');
              } else {
                toggleIsAward();
                errorNonification(res?.data?.message || 'Something went wrong');
              }
            } else {
              toggleIsAward();
              errorNonification(loginUser?.data?.message || 'Wrong password');
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        });
      }
    });
  };

  const [tenderAwardedTo, setTenderAwardedTo] = useState('');

  const getTenderAwardedTo = async (id) => {
    const res = await ApiManager.tenderAwardedTo(id);
    if (res.status === 200 && res?.data?.result) {
      setTenderAwardedTo(res.data.result);
    }
  };

  useEffect(() => {
    if (params.id) {
      getTenderAwardedTo(params.id);

      const interval = setInterval(() => {
        if (!tenderAwardedTo) {
          getTenderAwardedTo(params.id);
        }
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [params]);

  return (
    <div>
      <div className="mb-6">
        <BreadcrumbsWrapper breadcrumbs={breadcrumbs} />
      </div>
      <div className="text-2xl mb-12">Bids Download</div>

      {tenderData && (
        <div className="flex flex-col gap-8">
          <Grid container spacing={2}>
            {!didAllMembersOpen() && (
              <Grid item xs={12}>
                <div className="text-lg font-semibold">
                  Please open all committee members to download bids
                </div>
              </Grid>
            )}
            {/*   <Grid item xs={12}>
              <div className="flex gap-4 bg-white px-4 py-2 rounded-md">
                <div>{tenderData.user?.name}</div>
                <div>
                  {!didOpen([...tenderData.openBy], tenderData.user?._id) && (
                    <button
                      onClick={() => {
                        toggleViewBid();
                      }}
                      disabled={tenderData?.user?._id !== user._id}
                      className="text-xs text-white bg-main text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                    >
                      Open
                    </button>
                  )}
                </div>
              </div>
            </Grid> */}
            {tenderData?.userKey1 && (
              <Grid item xs={12}>
                <div className="flex gap-4 bg-white px-4 py-2 rounded-md">
                  <div>{tenderData.userKey1?.name}</div>
                  <div>
                    {!didOpen(
                      [...tenderData.openBy],
                      tenderData.userKey1?._id
                    ) && (
                      <button
                        onClick={() => {
                          toggleViewBid();
                        }}
                        disabled={tenderData?.userKey1?._id !== user._id}
                        className="text-xs text-white bg-main text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                      >
                        Open
                      </button>
                    )}
                  </div>
                </div>
              </Grid>
            )}
            {tenderData?.userKey2 && (
              <Grid item xs={12}>
                <div className="flex gap-4 bg-white px-4 py-2 rounded-md">
                  <div>{tenderData.userKey2?.name}</div>
                  <div>
                    {!didOpen(
                      [...tenderData.openBy],
                      tenderData.userKey2?._id
                    ) && (
                      <button
                        onClick={() => {
                          toggleViewBid();
                        }}
                        disabled={tenderData?.userKey2?._id !== user._id}
                        className="text-xs text-white bg-main text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                      >
                        Open
                      </button>
                    )}
                  </div>
                </div>
              </Grid>
            )}
            {tenderData?.userKey3 && (
              <Grid item xs={12}>
                <div className="flex gap-4 bg-white px-4 py-2 rounded-md">
                  <div>{tenderData.userKey3?.name}</div>
                  <div>
                    {!didOpen(
                      [...tenderData.openBy],
                      tenderData.userKey3?._id
                    ) && (
                      <button
                        onClick={() => {
                          toggleViewBid();
                        }}
                        disabled={tenderData?.userKey3?._id !== user._id}
                        className="text-xs text-white bg-main text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                      >
                        Open
                      </button>
                    )}
                  </div>
                </div>
              </Grid>
            )}
          </Grid>
        </div>
      )}

      {didAllMembersOpen() && (
        <div className="mt-12">
          <div className="flex justify-end mb-3">
            <CSVLink
              data={csvData}
              filename="tender-logs.csv"
              className="text-xs text-white bg-main text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
            >
              Download Bids As CSV
            </CSVLink>
          </div>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <div className="text-xl font-bold">Download Bids</div>
            </Grid>
            {Array.isArray(bids) &&
              bids.map((item, index) => (
                <Grid item key={item._id} xs={12}>
                  <div className="bg-white md:p-3 p-3 rounded-md">
                    <div className="flex justify-between items-center">
                      <div>
                        <span className="font-semibold">Name : </span>
                        {item?.user?.name}
                      </div>
                      <div>{moment(item?.createdAt).format('DD-MM-YYYY')}</div>
                    </div>

                    <div className="flex gap-3 flex-col mt-4">
                      {Array.isArray(item?.files) &&
                        item.files.map((file, index) => (
                          <div key={index} className="flex gap-4 items-center">
                            <span>{index + 1} : </span>
                            <a
                              className="text-[var(--blue)]"
                              href={toAbsolutePath(file)}
                              target="_blank"
                            >
                              Open
                            </a>
                            <a
                              className="text-[var(--pink)]"
                              href={toAbsolutePath(file)}
                              target="_blank"
                              download={file}
                            >
                              Download
                            </a>
                          </div>
                        ))}
                    </div>
                  </div>
                </Grid>
              ))}
            {!tenderAwardedTo ? (
              <Grid item xs={12}>
                <div className="flex justify-end">
                  <button
                    onClick={toggleIsAward}
                    className="text-xs text-black bg-[var(--yellow)] text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                  >
                    Award Tender
                  </button>
                </div>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <div className="text-lg text-center">
                  <span className="font-bold">
                    {tenderAwardedTo?.awardBy?.name}
                  </span>{' '}
                  awarded{' '}
                  <span className="font-bold">
                    {tenderAwardedTo?.tender?.tenderTitle}
                  </span>{' '}
                  to{' '}
                  <span className="font-bold">
                    {tenderAwardedTo?.awardTo?.name}
                  </span>
                </div>
              </Grid>
            )}
          </Grid>
        </div>
      )}

      <Modal
        open={isViewBid}
        onClose={() => {
          toggleViewBid();
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            minWidth: 300,
            bgcolor: '#fff',
            borderRadius: '10px',
            boxShadow: 24,
            p: 4,
          }}
        >
          <div className="text-lg font-bold mb-4">Password</div>

          <Formik
            initialValues={{
              password: '',
            }}
            validationSchema={yup.object().shape({
              password: validationSchema.required('Password'),
            })}
            onSubmit={async (values, actions) => {
              try {
                openDownloadBidForTender({ password: values.password });
              } catch (error) {
                console.log(error);
              }
            }}
          >
            {({
              values,
              touched,
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
            }) => (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <div className="flex flex-col gap-2">
                    <label className="text-xs">
                      Enter your password{' '}
                      <span className="text-red-500">*</span>
                    </label>
                    <TextFieldWrapper
                      placeholder="Password"
                      name="password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                      helperText={touched.password && errors.password}
                      error={!!touched.password && !!errors.password}
                    />
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <div className="flex items-center justify-between mt-4">
                    <button
                      onClick={toggleViewBid}
                      className="text-xs border border-1 border-[var(--blue)] text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                    >
                      Cancel
                    </button>

                    <button
                      onClick={handleSubmit}
                      className="text-xs bg-main text-white text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                    >
                      Open
                    </button>
                  </div>
                </Grid>
              </Grid>
            )}
          </Formik>
        </Box>
      </Modal>

      <Modal
        open={isAward}
        onClose={() => {
          toggleIsAward();
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            minWidth: 300,
            bgcolor: '#fff',
            borderRadius: '10px',
            boxShadow: 24,
            width: { md: '500px', sm: '400px', sm: '320px' },
            p: 4,
          }}
        >
          <div className="text-lg font-bold mb-4">Award Tender</div>

          <Formik
            initialValues={{
              awardTo: awardedUser,
            }}
            validationSchema={yup.object().shape({
              awardTo: validationSchema.required('Bidder'),
            })}
            onSubmit={async (values, actions) => {
              try {
                setAwardedUser(values.awardTo);
                handleAward(values.awardTo);
                toggleIsAward();
              } catch (error) {
                console.log(error);
              }
            }}
          >
            {({
              values,
              touched,
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
            }) => (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <div className="flex flex-col gap-2">
                    <label className="text-xs">
                      Select Bidder <span className="text-red-500">*</span>
                    </label>
                    <TextFieldWrapper
                      placeholder="Bidder"
                      name="awardTo"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.awardTo}
                      helperText={touched.awardTo && errors.awardTo}
                      error={!!touched.awardTo && !!errors.password}
                      select
                    >
                      <MenuItem value="">
                        <em>Slect</em>
                      </MenuItem>
                      {Array.isArray(bids) &&
                        bids.map((item, index) => (
                          <MenuItem item key={item._id} value={item?.user?._id}>
                            {item?.user?.name}
                          </MenuItem>
                        ))}
                    </TextFieldWrapper>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <div className="flex items-center justify-center gap-4 mt-4">
                    <button
                      onClick={toggleIsAward}
                      className="text-xs border border-1 border-[var(--blue)] text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                    >
                      Cancel
                    </button>

                    <button
                      onClick={handleSubmit}
                      className="text-xs bg-main text-white text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                    >
                      Award
                    </button>
                  </div>
                </Grid>
              </Grid>
            )}
          </Formik>
        </Box>
      </Modal>
    </div>
  );
}

export default Component;
